<template>
  <div>
    <div class="bg-static-default-hi h-56"></div>

    <div class="mt-32">
      If you need help with a Back Market order, please first message us here
      Still got questions? contact us here
    </div>
  </div>
</template>
